import {
  REGULAR_COLLECTIONS,
  SEEDSPECIES_COLLECTION,
} from 'constants/gcConstants';
import {
  G_CROPS_QUERY_KEY,
  M_CROPS_QUERY_KEY,
  M_SEARCH_CROPS_QUERY_KEY,
} from 'constants/queryKeys';
import { useCatalogueDropdown } from 'hooks/useCatalogueDropdown';
import { GSeedSpecies, MergedCrop } from 'interfaces/IGlobalCatalogue';
import { MSeedSpecies } from 'interfaces/IMasterDb';
import { composeSeedSpeciesList } from 'utils/catalogueMergeUtils';

/**
 * Crop (seed species) picker data — G/M merge, debounced search and infinite
 * scroll. Shared by the input attributes form in the workspace and the
 * create-plan modal so both crop dropdowns behave identically.
 * @param gOrgId - Active G organisation id
 * @param mOrgId - Resolved M organisation id, or null for a pure G list
 * @param selectedId - globalId of the currently selected crop, kept visible
 *                     in the browse list regardless of pagination position
 */
export const useCropCatalogue = (
  gOrgId: string | null,
  mOrgId: string | null,
  selectedId: string | null
) =>
  useCatalogueDropdown<GSeedSpecies, MSeedSpecies, MergedCrop>({
    gOrgId,
    mOrgId,
    gCollectionKey: SEEDSPECIES_COLLECTION,
    mCollectionKey: SEEDSPECIES_COLLECTION,
    gSearchCollectionName: REGULAR_COLLECTIONS.seedSpecies,
    gQueryKey: [G_CROPS_QUERY_KEY],
    mQueryKey: [M_CROPS_QUERY_KEY],
    searchQueryKey: [M_SEARCH_CROPS_QUERY_KEY],
    mergeItems: composeSeedSpeciesList,
    selectedId,
  });
